/**
 * Note — информационная плашка с приглушённым текстом для пояснений на экране.
 * variant: "default" — нейтральная; "warning" — янтарная; "success" — зелёная; "danger" — красная.
 */
import type { ReactNode } from "react";

type Variant = "default" | "warning" | "success" | "danger";
type Props = { children: ReactNode; className?: string; variant?: Variant };

const LOOKS: Record<Variant, string> = {
  default: "border-white/[0.06] bg-surface-card text-white/70",
  warning: "border-amber-400/20 bg-amber-400/10 text-amber-200/90",
  success: "border-emerald-400/20 bg-emerald-400/10 text-emerald-200/90",
  danger: "border-red-500/20 bg-red-500/10 text-red-300",
};

export function Note({ children, className = "", variant = "default" }: Props) {
  return (
    <div className={`rounded-2xl border px-4 py-3 text-[13px] leading-snug ${LOOKS[variant]} ${className}`}>
      {children}
    </div>
  );
}
